import { render, staticRenderFns } from "./BrandDetail.vue?vue&type=template&id=7685252f"
import script from "./BrandDetail.vue?vue&type=script&lang=js"
export * from "./BrandDetail.vue?vue&type=script&lang=js"
import style0 from "./BrandDetail.vue?vue&type=style&index=0&id=7685252f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_efc848e9267e82724df6d0a8b137201b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports